/* globals moment */

/**
 * Flash a new notification.
 *
 * @param options
 */
export function flash(options) {
  Event.fire('flash', options);
}

/**
 * Uppercase first letter of a string.
 *
 * @param string
 * @return {string}
 */
export function ucfirst(string) {
  return string[0].toUpperCase() + string.slice(1);
}

/**
 * Lowercase first letter of a string.
 *
 * @param string
 * @return {string}
 */
export function lcfirst(string) {
  return string[0].toLowerCase() + string.slice(1);
}

/**
 * Capitalize a string.
 *
 * @param string
 * @return {string}
 */
export function capitalize(string) {
  return string.split(' ').map(item => ucfirst(item)).join(' ');
}

/**
 * Format a phone number.
 *
 * @param {*} string
 */
export function formatPhone(string, separator = ' ') {
  return string.match(/\d{2}/g).join(separator);
}

/**
 * Merge two objects.
 *
 * @param source
 * @param object
 */
export function merge(source, object) {
  Object.keys(object).forEach((field) => {
    if (Object.prototype.hasOwnProperty.call(source, field)) {
      source[field] = object[field];
    }
  });
}

/**
 * Transform a snake string to a camel case string.
 *
 * @param {String} string
 */
export function snakeToCamel(string) {
  return string.replace(/(-\w)/g, match => match[1].toUpperCase());
}

/**
 * Wrap the given value with an array if it is not already an array.
 *
 * @param {*} value
 */
export function arrayWrap(value) {
  return Array.isArray(value) ? value : [value];
}

/**
 * Format a weekday number to a readable string.
 *
 * @param {integer} weekday
 * @param {string} format
 * @return {string}
 */
export function formatWeekday(weekday, format) {
  // in moment.js sunday is the day 0
  return ucfirst(
    moment()
      .day(weekday !== 7 ? weekday : 0)
      .format(format || 'dddd')
      .replace('.', ''),
  );
}
